import React, { Component } from 'react';
import Overview from './Overview';
import Form from './Form';
import {Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';
import { connect } from 'react-redux'
class Clients extends Component {	
  
	render() { 			
        return (
            <Switch>
                <Route exact path="/clients" name="Overview" render={(location) => <Overview />}/>  
                <Route exact path="*/update/:clientId" name="Form" render={(location) => <Form />}/>            
              </Switch>
        )
  	}
}

function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer, 
        searchData: state.SearchDataReducer       
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Clients))



// WEBPACK FOOTER //
// ./src/views/Clients/index.js